import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { fetchBlogDetail, fetchCategories, fetchRecentBlogPosts, selectFormattedCategories } from "@/store/modern/slices/newsAndEventSlice";
import moment from "moment";
import defaultValues from "@/constant/defaultValues";
import { isEmpty, map, size } from "lodash";
import { publicRoutePaths } from "@/routes/public.routes.config";
import { buildPath } from "@/utils/common";
import SubscriptionForm from "@/modules/frontend/components/Blog/SubscriptionForm";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  XIcon
} from "react-share";
import { ToastContainer } from "react-toastify";
import ConsentManager from "../../components/ConsentManager";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";
import PopUp from '@/modules/frontend/components/PopUp';
import BookADemo from '@/modules/frontend/components/BookADemo';

// import otherRoutes from "@/routes/other.routes.config";
export default function Index() {

  const { blog_title } = useParams();
  const dispatch = useDispatch();
  const blog_detail = useSelector(state => state.galleryImages.blog_detail, shallowEqual);
  const categories = useSelector(selectFormattedCategories);
  const recentPosts = useSelector(state => state.galleryImages.recentBlogs, shallowEqual);
  const [smallmodalShow, setSmallModalShow] = useState(false);

  const { BASE_URL } = defaultValues.IMAGE_PATH;
  const nav = useNavigate();

  const handleQuoteClick = () => {
    setSmallModalShow(true);
  };

  const getBlogDetail = async (blog_title) => {
    const result = await dispatch(fetchBlogDetail(blog_title));
    await dispatch(fetchCategories());
    // if (isEmpty(result.payload)) {
    //   nav(otherRoutes.PAGE_404_NOT_FOUND.path);
    // }
    if (isEmpty(result.payload)) {
      nav(publicRoutePaths.BLOG_LIST.path);
    }
  }

  const stripHtml = (html) => {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent.slice(0, 150) || tmp.innerText.slice(0, 150) || "";
  }

  useEffect(() => {
    if (blog_detail && isEmpty(recentPosts)) {
      dispatch(fetchRecentBlogPosts(blog_detail.id));
    }
  }, [blog_detail, recentPosts]);

  useEffect(() => {
    getBlogDetail(blog_title);
  }, [blog_title]);


  return (
    <>
      <section className="inner-pad page blog-detail-page">
        <SeoHelmet
          title={blog_detail?.title || seoConfig.blogs.title}
          description={blog_detail?.meta_description || seoConfig.blogs.description}
          keywords={blog_detail?.meta_keywords || seoConfig.blogs.keywords}
          author={seoConfig.blogs.author}
        />

        <button
          className="btn outline small sticky-btn"
          onClick={handleQuoteClick}
          type="button"
        >
          Book A Demo
        </button>
        {/* inner banner wrape START  */}
        <div className="inner-banner blog-detail-wrape">
          <div className="container">
            <div className="content-wrape desk-hide">
              <h2>
                <span className="light">
                  Explore
                </span> &nbsp;
                <span className="blue">
                  Our
                </span> &nbsp;
                <span className="black">
                  Blog
                </span>
              </h2>
              <p>Expert perspectives, event highlights and industry updates</p>
            </div>
          </div>
        </div>
        {/* inner banner wrape END  */}

        <div className="container map-bg">
          <div className=" inner-page-content-wrape">
            <div className="content-wrape mobile-show page-head ">
              <h2 className="mobile-head-text animate-child">
                <span className="light">
                  Explore
                </span> &nbsp;
                <span className="blue">
                  Our
                </span> &nbsp;
                <span className="black">
                  Blog
                </span>
              </h2>
              <p className="animate-child">Expert perspectives, event highlights and industry updates</p>
            </div>

            <div className='row'>
              <div className='col-xxl-9 col-xl-9 col-lg-8'>
                <div className='blog-card'>
                  <div className='detail-wrape'>
                    <h1>{blog_detail && blog_detail.title}</h1>
                    <div className="other-info-wrape">
                      <ul className='info-pad'>
                        <li>
                          <i className='calendar'></i>
                          {blog_detail && moment(blog_detail.blog_publish_date).format("ll")}
                        </li>
                        {/* <li>
                          <i className='user'></i>
                          Admin
                        </li> */}
                        <li className="category">{blog_detail && blog_detail.category.category_name}</li>
                      </ul>

                      {
                        blog_detail && <ul className="social-share">
                          <li>Share:</li>
                          <li>
                            {/* <Link to="" title="" className="in"></Link> */}
                            <LinkedinShareButton url={`https://orextrade.com${buildPath(publicRoutePaths.BLOG_DETAIL, { blog_title: blog_title })}`} title={blog_detail.title}>
                              <LinkedinIcon size={32} round={true} />
                            </LinkedinShareButton>

                          </li>
                          <li>
                            <TwitterShareButton url={`https://orextrade.com${buildPath(publicRoutePaths.BLOG_DETAIL, { blog_title: blog_title })}`} title={blog_detail.title}>
                              <XIcon size={32} round={true} />
                            </TwitterShareButton>
                          </li>
                          <li>
                            <FacebookShareButton url={`https://orextrade.com${buildPath(publicRoutePaths.BLOG_DETAIL, { blog_title: blog_title })}`} title={blog_detail.title}>
                              <FacebookIcon size={32} round={true} />
                            </FacebookShareButton>
                            {/* <Link to="" title="" className="share"></Link> */}
                          </li>
                        </ul>
                      }

                    </div>
                  </div>
                  <div className='img-wrape'>
                    {
                      blog_detail && <img src={`${BASE_URL}${blog_detail.image}`} alt="" />
                    }
                  </div>

                  <div className="blog-content-wrape">
                    {
                      blog_detail && <div
                        dangerouslySetInnerHTML={{
                          __html: blog_detail?.content,
                        }}
                      ></div>
                    }
                  </div>
                </div>
              </div>
              <div className='col-xxl-3 col-xl-3 col-lg-4'>
                <div className='gray-box category'>
                  <h3>CATEGORIES</h3>
                  <ul className="">
                    {
                      categories && map(categories, (category) => {
                        return (<li key={`cat_${category.id}`}>
                          <Link to={`${publicRoutePaths.BLOG_LIST.path}?c=${category.id}`} title={`${category.text}`}
                            href={`${publicRoutePaths.BLOG_LIST.path}?c=${category.id}`}
                            target="_blank"
                          >{category.text} <span>({category.blog_count})</span></Link>
                        </li>)
                      })
                    }
                  </ul>
                </div>

                {
                  size(recentPosts) > 0 && <div className='gray-box recent'>
                    <h3>Recent Posts</h3>
                    <ul className="">
                      {
                        recentPosts && map(recentPosts, (val) => {
                          return (
                            <li key={`rp_${val.id}`}>
                              <Link to={`${buildPath(publicRoutePaths.BLOG_DETAIL, { blog_title: val.slug })}`}
                                className="post" title={val.title} target="_blank" href={`${buildPath(publicRoutePaths.BLOG_DETAIL, { blog_title: val.slug })}`}>
                                <div className="img-thumb">
                                  <img src={BASE_URL + val.image} alt="" />
                                </div>
                                <p>{val.title}</p>
                              </Link>
                            </li>
                          )
                        })
                      }
                    </ul>
                  </div>
                }


                <div className='gray-box subscribe'>
                  <SubscriptionForm />
                </div>
                {/* <div className='gray-box subscribe'>
                  <h3>NEWSLETTER</h3>
                  <div className="form-wrape">
                    <div className="input-wrape">
                      <input type="text" placeholder="Your Name" />
                    </div>
                    <div className="input-wrape">
                      <input type="text" placeholder="Email Address" />
                    </div>

                    <button className="btn red-btn full" type="submit">Subscribe</button>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <ConsentManager data={""} />
        {smallmodalShow && (
          <PopUp
            title="Book A Demo"
            smallmodalShow={smallmodalShow}
            setSmallModalShow={setSmallModalShow}
            className="book-demo"
          >
            <BookADemo
              setSmallModalShow={setSmallModalShow} />
          </PopUp>
        )}
        <ToastContainer />
      </section>
    </>
  )
}
